import { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import "../../styling/Donut.css";

const AnalyticsDonut = () => {
  const [bookedCount, setBookedCount] = useState(0);
  const [cancelledCount, setCancelledCount] = useState(0);
  // For non-booked, since no API, keep as static (or calculate as total - booked - cancelled if you want)
  const nonBookedCountStatic = 0;

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    async function fetchData() {
      try {
        const [bookedRes, cancelledRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/business/events`, {withCredentials: true}),
          axios.get(`${process.env.REACT_APP_API_URL}/business/cancelledEvents`, {withCredentials: true}),
        ]);

        const bookedEvents = bookedRes.data.data;
        const cancelledEvents = cancelledRes.data.data;

        const bookedThisYear = bookedEvents.filter(event => {
          const d = new Date(event.createdAt);
          return d.getFullYear() === currentYear;
        }).length;

        const cancelledThisYear = cancelledEvents.filter(event => {
          const d = new Date(event.createdAt);
          return d.getFullYear() === currentYear;
        }).length;

        setBookedCount(bookedThisYear);
        setCancelledCount(cancelledThisYear);
      } catch (error) {
        console.error("Error fetching donut chart data:", error);
      }
    }
    fetchData();
  }, [currentYear]);

  // Calculate total to get percentages for donut chart
  const total = bookedCount + cancelledCount + nonBookedCountStatic || 1; // Avoid div by zero

  const bookedPercent = Math.round((bookedCount / total) * 100);
  const cancelledPercent = Math.round((cancelledCount / total) * 100);
  const nonBookedPercent = 100 - bookedPercent - cancelledPercent;

  const data = {
    labels: ["Booked", "Non-booked", "Cancelled"],
    datasets: [
      {
        data: [bookedPercent, nonBookedPercent, cancelledPercent],
        backgroundColor: ["#21A62C", "#F99600", "#E02121"],
        // hoverBackgroundColor: ["#260F99", "#B5A6FF", "#D9D9D9"],
      },
    ],
  };

  const labels = data.labels.map((label, i) => ({
    label,
    value: data.datasets[0].data[i],
    backgroundColor: data.datasets[0].backgroundColor[i],
  }));

  return (
    <div className="right-donut" style={{paddingBottom: '20px'}}>
      <h2
        style={{
          paddingTop: "20px",
          paddingLeft: "30px",
          fontWeight: "500",
          color: "#1C1154",
        }}
      >
        Success Rate
      </h2>

      <div className="donut">
        <Doughnut
          style={{ width: "140px", height: "120px" }}
          data={data}
          options={{
            cutout: "80%",
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
          }}
        />
      </div>

      {/* Custom Legend */}
      <div className="custom-legend">
        {labels.map((item, index) => (
          <div key={index} className="legend-item">
            <div
              className="color-box"
              style={{ backgroundColor: item.backgroundColor }}
            ></div>
            <div className="legend-label">{item.label}</div>
            <div className="legend-value">{item.value}%</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsDonut;
